import React, { useLayoutEffect, useMemo } from 'react'
import { typeCheck } from 'type-check'
import FieldDebug from './fieldDebug'
import classNames from 'classnames'

const UnknownFieldDetailItem = (props) => {
  const {
    debug = false,
    measure,
    opportunity,
    fieldDefinition,
    field,
    hideWhenEmpty = false,
    className = '',
    labelClassName = '',
  } = props

  const { label } = fieldDefinition
  const { value } = field

  useLayoutEffect(() => {
    const req = requestAnimationFrame(() => {
      measure && measure()
    })
    return () => {
      req && cancelAnimationFrame(req)
    }
  }, [measure])

  const renderedValue = useMemo(() => {
    if (typeCheck('Object', value)) {
      return JSON.stringify(value)
    } else {
      return value || '-'
    }
  }, [])

  return (
    <>
      {!value && hideWhenEmpty
        ? (<></>)
        : (
          <div className={classNames('UnknownFieldDetailItem', { 'my-4': !className }, { [className]: className })}>
            <div className="flex items-center justify-between text-color-09242f text-size-16px font-weight-600 truncate">
              {label}
              <FieldDebug
                debug={debug}
                data={{ opportunity, fieldDefinition, field }} />
            </div>
            <div
              style={{ transform: 'translateY(-1px)' }}
              className={classNames('text-color-09242f text-size-16px font-weight-300', labelClassName)}>
              {renderedValue}
            </div>
          </div>
        )}
    </>
  )
}

export default UnknownFieldDetailItem
